import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from 'posthog-js/react';
import { App } from './App';
import { AuthProvider } from './features/auth/hooks/useAuth';
import { KaraokeProvider } from './contexts/KaraokeContext';
import { queryClient } from './lib/queryClient';
import posthog from './lib/posthog';

import './styles/app.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <KaraokeProvider>
            <App />
          </KaraokeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </PostHogProvider>
  </React.StrictMode>
);